import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import siliconLab from "../../../assets/images/Footer.png";

import "./style.scss";

const ActionBar = forwardRef((props, ref) => {
  const { panoRef, autoRotatePlaying, onToggleAutoRotate } = props;
  const [, setFilter] = useState(props.filter);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.().catch(() => {});
    } else {
      document.exitFullscreen?.();
    }
  };

  useEffect(() => {
    // Event listener setup (commented code suggests this was for share toggler)
    // Keeping empty effect for potential future use
    return () => {
      // Cleanup if needed
    };
  }, [])


  useImperativeHandle(
    ref,
    () => ({
      closeFilter() {
        setFilter(false)
      }
    }),
    []
  )


  const handleRedirect = () => props.onHome?.();
    
  const pano = panoRef?.current;

  return (
    <div className="action-bar-wrapper">
      <div className="action-bar-controls">
        <button type="button" className="action-bar-control" onClick={() => pano?.zoomIn()} aria-label="Zoom in" title="Zoom in">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M11 8v6M8 11h6"/></svg>
        </button>
        <button type="button" className="action-bar-control" onClick={() => pano?.zoomOut()} aria-label="Zoom out" title="Zoom out">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M8 11h6"/></svg>
        </button>
        <button type="button" className="action-bar-control" onClick={toggleFullscreen} aria-label={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'} title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}>
          {isFullscreen ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="miter">
              <path d="M7 7 L10 7 L12 9 L14 7 L17 7 L17 10 L15 12 L17 14 L17 17 L14 17 L12 15 L10 17 L7 17 L7 14 L9 12 L7 10 Z" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="miter">
              <path d="M3 3 L9 3 L12 6 L15 3 L21 3 L21 9 L18 12 L21 15 L21 21 L15 21 L12 18 L9 21 L3 21 L3 15 L6 12 L3 9 Z" />
            </svg>
          )}
        </button>
        <button type="button" className="action-bar-control" onClick={onToggleAutoRotate} aria-label={autoRotatePlaying ? 'Pause auto-rotate' : 'Play auto-rotate'} title={autoRotatePlaying ? 'Pause auto-rotate' : 'Play auto-rotate'}>
          {autoRotatePlaying ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>
          )}
        </button>
        <button type="button" className="action-bar-control" onPointerDown={() => pano?.startPanUp()} onPointerUp={() => pano?.stopPan()} onPointerLeave={() => pano?.stopPan()} aria-label="Pan up" title="Pan up">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg>
        </button>
        <button type="button" className="action-bar-control" onPointerDown={() => pano?.startPanDown()} onPointerUp={() => pano?.stopPan()} onPointerLeave={() => pano?.stopPan()} aria-label="Pan down" title="Pan down">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
        </button>
        <button type="button" className="action-bar-control" onPointerDown={() => pano?.startPanLeft()} onPointerUp={() => pano?.stopPan()} onPointerLeave={() => pano?.stopPan()} aria-label="Pan left" title="Pan left">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
        </button>
        <button type="button" className="action-bar-control" onPointerDown={() => pano?.startPanRight()} onPointerUp={() => pano?.stopPan()} onPointerLeave={() => pano?.stopPan()} aria-label="Pan right" title="Pan right">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
        <button type="button" className="action-bar-control" onClick={() => props.onHome?.()} aria-label="Home" title="Home">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
        </button>
      </div>
      <div className="row w-100">
      <div onClick={handleRedirect} className="action-bar-logo ml-3 cursor-pointer">
          <div className="silicon-lab-anchor">
            <img src={siliconLab} className="silicon-lab-logo" alt="EPA logo" />
          </div>
      </div>
        <div className="actions-wrap">
        {/* <div> */}
          {/* <div className="cursor-pointer filter" id="filter" onClick={()=>setFilter(!filter)}>
      <img className="action-icon" src={filterIcon} />
      <p className="action-text">FILTER</p>
      </div>
      {filter && <div className="text-white filter-modal" id="filterModal">
        <div className="filter-head">
          <span className="filter-heading">Filters</span>
          <span className="cursor-pointer filter-reset" onClick={handleReset}>Reset</span>
        </div>
        <div className="filter-body">
          <div className="toggler cursor-pointer" onClick={()=>{setEcoSystem(!ecoSystem);setProtocol(false)}}>
            <span>ECOSYSTEM</span>
            <img src={ecoSystem ? minusIcon : plusIcon}/>
          </div> */}
        {/* <Collapse isOpen={ecoSystem}>
        {ecosystems.map((v,i)=>{
          return(
          <div className="list-item" key={i}>
            <div className="item-sub">
            <span>{v.title}</span>
            <div className="item-checkbox">
            <input name={v.name} onChange={(e)=>handleCheckChange(v.name,e.target.checked)} type="checkbox" className="check-boxes"/>
            <img src={selected[v.name]?checkedIcon:uncheckedIcon}/>
            </div>
            </div>
            </div>

          )
        })}
      </Collapse> */}
      {/* <div className="toggler cursor-pointer"  onClick={()=>{setProtocol(!protocol);setEcoSystem(false)}}>
            <span>PROTOCOLS</span>
            <img src={protocol ? minusIcon : plusIcon}/>
          </div>
        <Collapse isOpen={protocol}>
        {protocols.map((v,i)=>{
          return(
          <div className="list-item" key={i}>
            <div>
            <div className="item-sub">
            <span>{v.title}</span>
            <div className="item-checkbox">
            <input name={v.name} onChange={(e)=>handleCheckChange(v.name,e.target.checked)} type="checkbox" className="check-boxes"/>
            <img src={selected[v.name]?checkedIcon:uncheckedIcon}/>
            </div>
           
            </div>
            </div>
            </div>

          )
        })}
      </Collapse>
      <center><button className="show-results mt-4" onClick={()=>props.openFilterResults(selected)}>SHOW RESULTS</button></center>
        </div>
        
      </div>}
      </div> */}
      {/* <center className="share-wrap cursor-pointer" id="sharemain" style={{ marginTop:"-20px"}}> */}
        {/* <div id="sharewrap" className="hidden-wrap"> */}
        {/* <a href="mailto:?body=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareEmailIcon}/>
      </a><br/> */}

      {/* <a href="https://twitter.com/intent/tweet?text=silabs.com&url=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareTwitterIcon}/>
      </a><br/> */}

      {/* <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareLinkedIcon}/>
      </a><br/> */}
      {/* </div> */}
      {/* <div id="shareToggler" className="share-toggler" onClick={handleShowShareBar}> */}
      {/* <img className="action-icon" src={shareIcon}/> */}
      {/* <p className="action-text">SHARE</p> */}
      {/* </div> */}
      {/* </center> */}

      {/* <center className="ml-3 cursor-pointer" onClick={() => setShowTutorial(true)}> */}
      {/* <img className="action-icon" src={helpIcon} /> */}
      {/* <p className="action-text">HELP</p> */}
      {/* </center> */}
        </div>
      </div>
      </div>
    // </div>
  );
})

export default ActionBar;
